import React from 'react';

import { LanguageTranslationKeys } from 'i18n/languages/en';
import store from 'store';

import BooksIcon from '@common/assets/icons/Books.svg';
import CalendarMonthIcon from '@common/assets/icons/CalendarMonth.svg';
import CertificatesIcon from '@common/assets/icons/Certificates.svg';
import DescriptionOutlinedIcon from '@common/assets/icons/DescriptionOutlined.svg';
import FileInvoiceIcon from '@common/assets/icons/FileInvoice.svg';
import MessageIcon from '@common/assets/icons/Messages.svg';
import NewsIcon from '@common/assets/icons/News.svg';
import NotebookIcon from '@common/assets/icons/Notebook.svg';
import SchoolIcon from '@common/assets/icons/School.svg';
import UserIcon from '@common/assets/icons/User.svg';
import HomeIcon from '@common/assets/icons/home.svg';
import { ROLE, checkRole } from '@common/components/RBAC';
import type { MenuItemWithText } from '@common/constants/CampusMenuTypes';
import { getRoute } from '@common/constants/CampusRoutes';
import getAppointmentTranslationKey from '@common/modules/ClientApp/helpers/getAppointmentTranslationKey';

const useGetMenuMobile = () => {
	const isParentInServiceOne = checkRole(ROLE.PARENT) && store.services.current?.id === 1;
	const isCreditsTisStudent = store.profile.isCreditsTisStudentView;

	const chatMenuItem: MenuItemWithText<LanguageTranslationKeys> = {
		icon: <MessageIcon />,
		text: 'chat.main',
		href: getRoute(['CHAT']),
		services: [1, 2, 3],
		excludeRoles: ['Partner', 'Partner Invitee'],
	};

	const MENU_MOBILE: MenuItemWithText<LanguageTranslationKeys>[] = [
		{
			icon: <HomeIcon />,
			text: 'home.main',
			href: getRoute(['HOME']),
			services: [1, 2, 3, 4],
		},
		{
			icon: <UserIcon />,
			text: 'profile.main',
			href: '/profile',
			services: [1, 2, 3, 4],
			excludeInMenuListServices: [1, 3],
		},
		{
			icon: <SchoolIcon />,
			text: 'programs.main',
			href: getRoute(['PROGRAMS']),
			services: [1, 2, 3, 4, 5],
			excludeRoles: ['Partner'],
		},
		{
			icon: <NotebookIcon />,
			text: 'header.toolbar.gradebook',
			href: '/gradeBook',
			services: [2, 3],
			excludeRoles: ['Partner', 'Partner Invitee'],
		},
		...(isCreditsTisStudent ? [
			{
				icon: <CalendarMonthIcon />,
				text: 'header.toolbar.billing',
				href: getRoute(['BILLING']),
				services: [3],
				onlyFor: ['Student'],
			} as MenuItemWithText<LanguageTranslationKeys>,
		] : []),
		{
			icon: <CalendarMonthIcon />,
			text: getAppointmentTranslationKey(),
			href: getRoute(['APPOINTMENTS']),
			services: [1, 2],
		},
		{
			icon: <NewsIcon />,
			text: 'news.main',
			href: getRoute(['NEWS']),
			services: [1, 2, 3, 4, 5],
			excludeRoles: ['Partner', 'Partner Invitee'],
		},
		{
			icon: <FileInvoiceIcon />,
			text: 'header.toolbar.report',
			href: getRoute(['REPORT']),
			services: [2],
		},
		{
			icon: <FileInvoiceIcon />,
			text: 'header.toolbar.report',
			href: getRoute(['REPORT']),
			services: [1],
			onlyFor: ['Parent'],
		},

		{
			icon: <BooksIcon />,
			text: 'resources.main',
			href: getRoute(['BOOKS']),
			services: [1, 2, 3, 4],
			excludeRoles: ['Partner', 'Partner Invitee'],
		},
		...((!isParentInServiceOne && !isCreditsTisStudent) ? [chatMenuItem] : []),

		...(isCreditsTisStudent ? [] : [{
			icon: <DescriptionOutlinedIcon />,
			text: 'policies.main',
			href: '/policies',
			services: [3],
			excludeRoles: ['Partner', 'Partner Invitee'],
		} as MenuItemWithText<LanguageTranslationKeys>]),
		{
			icon: <CertificatesIcon />,
			text: 'header.toolbar.certificates',
			href: getRoute(['CERTIFICATES']),
			services: [1],
		},
	];

	return MENU_MOBILE;
};

export default useGetMenuMobile;
